import BasicInput from './BasicInput';

export default BasicInput;